/** Feature flags — toggle modules without removing code. */
export const FEATURES = {
  PROJECTS_ENABLED: false,
};
